<template>
  <div class="it_hardware_wrap">
    <div class="it_hardware_img" id="cpjz">
      <div class="production_img_inner">
<!--        <div class="img_desc">良悦企业资源计划管理系统解决方案</div>-->
        <div class="img_tit">一站式数据中心建设解决方案服务商</div>
<!--                <div class="img_desc">从底层硬件到顶层架构的全栈式数字化基座构建者</div>-->
        <router-link class="img_btn" to="/Experience">立即咨询</router-link>
      </div>

    </div>
    <div class="tab-area hidden-xs-only">
      <div class="tab-area-bg"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="服务定位" name="first"></el-tab-pane>
        <el-tab-pane label="数据中心建设方案" name="second"></el-tab-pane>
        <el-tab-pane label="产品与设备" name="third"></el-tab-pane>
        <el-tab-pane label="合作伙伴" name="fourth"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="service-card" >
      <div class="it_hardware_inner">
        <div class="inner_center">
          <div class="it_hardware_title">服务定位</div>
          <div class="it_hardware_desc">您值得信赖的一站式数据中心建设解决方案伙伴</div>
        </div>
      </div>
      <div class="it_hardware_box hidden-sm-and-up" >
        <div class="it_hardware_item">
          <div class="title">
            <img  src="../../assets/img/iT/yzs.png"/>
            <div>一站式采购平台</div>
            <div class="content">覆盖服务器、存储、网络设备、计算终端、工作站、核心机房设备、网络安全硬件及周边设备等多品类IT硬件。</div>
          </div>
        </div>
        <div class="it_hardware_item">
          <div class="title">
            <img  src="../../assets/img/solution/zlxt.png"/>
            <div>专业解决方案设计</div>
            <div class="content">基于您的具体业务场景（如AI计算、云计算/混合云、核心数据中心、智能办公、连锁门店等），提供量身定制的、预集成、预验证的硬件方案包。</div>
          </div>
        </div>
        <div class="it_hardware_item">
          <div class="title">
            <img  src="../../assets/img/solution/jczc.png"/>
            <div>全生命周期管理</div>
            <div class="content">提供涵盖设备选型、采购、安装、配置、监控、维护、升级乃至退役回收的一站式生命周期管理服务，为您管理IT资产减负。</div>
          </div>
        </div>
        <div class="it_hardware_item">
          <div class="title">
            <img  src="../../assets/img/solution/znhsj.png"/>
            <div>技术与成本的双重优化</div>
            <div class="content">依托广泛的产品线和规模化议价能力，提供具有竞争力的价格；</div>
            <div class="content">通过专业配置建议，消除资源浪费。</div>
          </div>
        </div>
      </div>
      <div class="it_hardware_box dingwei-bg hidden-xs-only">
        <div class="it_hardware_item">
          <img src="../../assets/img/iT/fwdw_04.jpg" />
          <div class="title">一站式采购平台
            <div class="content">覆盖服务器、存储、网络设备、计算终端、工作站、核心机房设备、网络安全硬件及周边设备等多品类IT硬件。</div>
          </div>
        </div>
        <div class="it_hardware_item">
          <img src="../../assets/img/iT/fwdw_03.jpg" />
          <div class="title">专业解决方案设计
            <div class="content">基于您的具体业务场景（如AI计算、云计算/混合云、核心数据中心、智能办公、连锁门店等），提供量身定制的、预集成、预验证的硬件方案包。</div>
          </div>
        </div>
        <div class="it_hardware_item">
          <img src="../../assets/img/iT/fwdw_02.jpg" />
          <div class="title">全生命周期管理
            <div class="content">提供涵盖设备选型、采购、安装、配置、监控、维护、升级乃至退役回收的一站式生命周期管理服务，为您管理IT资产减负。</div>
          </div>
        </div>
        <div class="it_hardware_item">
          <img src="../../assets/img/iT/fwdw_01.jpg" />
          <div class="title">技术与成本的双重优化
            <div class="content">依托广泛的产品线和规模化议价能力，提供具有竞争力的价格；</div>
            <div class="content second-content">通过专业配置建议，消除资源浪费。</div>
          </div>
        </div>
      </div>
    </div>
    <div class="tedian dingwei-bottom" >
        <div class="it_hardware_inner">
          <div class="inner_center hidden-xs-only" >
            <div class="it_hardware_title" id="jsfa">专注于成为企业客户全方位的数据中心建设解决方案服务商</div>
            <div class="it_hardware_desc">整合IT硬件资源与深厚的专业技术能力，致力于为您的业务提供从咨询到部署、</div>
            <div class="it_hardware_desc">从采购到维保的全流程、一体化服务。</div>
          </div>
          <div class="inner_center hidden-sm-and-up" >
            <div class="it_hardware_title">专注于成为企业客户全方位的数据中心建设解决方案服务商</div>
            <div class="it_hardware_desc">整合IT硬件资源与深厚的专业技术能力，致力于为您的业务提供从咨询到部署、从采购到维保的全流程、一体化服务。</div>
          </div>
        </div>
    </div>
    <div class="center-area " >
      <div class="it_hardware_inner">
        <div class="inner_center">
          <div class="it_hardware_title">IT建设方案</div>
        </div>
      </div>
      <div class="tab-content" style="margin-bottom: 0">
        <el-radio-group v-model="tabRadio" class="hidden-xs-only">
          <el-radio-button label="1">虚拟化平台建设</el-radio-button>
          <el-radio-button label="2">超融合平台建设</el-radio-button>
          <el-radio-button label="3">业务容灾解决方案</el-radio-button>
          <el-radio-button label="4">企业基础网络建设</el-radio-button>
          <el-radio-button label="5">无线网络建设</el-radio-button>
        </el-radio-group>
        <el-radio-group v-model="tabRadio" class="hidden-sm-and-up">
          <el-radio-button label="1">虚拟化平台建设</el-radio-button>
          <el-radio-button label="2">超融合平台建设</el-radio-button>
          <el-radio-button label="3">业务容灾解决方案</el-radio-button>
        </el-radio-group>
        <el-radio-group v-model="tabRadio" class="hidden-sm-and-up">
          <el-radio-button label="4">企业基础网络建设</el-radio-button>
          <el-radio-button label="5">无线网络建设</el-radio-button>
        </el-radio-group>
      </div>
      <div class="row-div">
        <el-row>
          <el-col :span="24" class="hidden-sm-and-up" v-if="tabRadio==='1'"><div class="hx-img height1" style="text-align: center"><img src="../../assets/img/iT/case1-bg.png" /></div></el-col>
          <el-col :span="12" :xs="24" class="hx-text height1" v-if="tabRadio==='1'">
            <div class="title-sub1">构建敏捷、弹性、安全的数字化底座</div>
            <div class="title-sub2">虚拟化平台建设是当代企业IT架构转型的核心策略，其优势与价值不仅体现在资源优化和成本节约上，更在业务连续性、管理效率和安全性等方面带来变革性提升。</div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">资源优化与成本节约</div>
              <div class="desc">通过将物理服务器抽象为虚拟资源池，实现多虚拟机（VM）共享单台物理硬件，显著提升资源利用率。</div>
              <div class="desc">虚拟化平台支持按需动态分配CPU、内存、存储等资源，无需停机即可横向扩展，适应业务高峰需求。</div>
              <div class="desc">通过集中化管理工具（如vCenter），减少多物理机部署的重复授权费用，尤其在大规模部署中更具成本效益。</div>
            </div>
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">业务连续性与可靠性增强</div>
              <div class="desc">快速故障恢复：VMware vSphere HA可在物理主机故障时自动重启虚拟机，减少停机时间；FT技术实现零宕机容错。</div>
                <div class="desc">灾难恢复：虚拟机快照、备份（如VDP）和跨站点迁移（如vMotion）确保数据安全，恢复时间目标（RTO）从小时级缩短至分钟级。</div>
            </div>
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">运维管理与敏捷性提升</div>
              <div class="desc">通过统一控制台（如vCenter、Hyper-V Manager）管理上千台虚拟机，提升运维效率。
                自动化部署模板加速应用交付，新虚拟机部署时间从数天缩短至分钟级。</div>
            </div>
            <el-button type="primary" round class="hx-btn" @click="toZixun">了解虚拟化平台</el-button>
          </el-col>
          <el-col :span="12" class="hidden-xs-only" v-if="tabRadio==='1'"><div class="hx-img height1" style="text-align: right"><img src="../../assets/img/iT/case1-bg.png" /></div></el-col>
          <el-col :span="12" :xs="24"  v-if="tabRadio==='2'"><div class="hx-img height1"><img src="../../assets/img/iT/case2-bg.png" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='2'"><div class="hx-text height1">
            <div class="title-sub1">以软件为中心，替代传统架构</div>
            <div class="title-sub2">超融合平台（Hyper-Converged Infrastructure, HCI）通过整合计算、存储、网络等资源，以软件定义方式实现统一管理，为企业数字化转型提供了高效、灵活的IT基础架构。 </div>
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">架构简化与成本优化</div>
              <div class="desc">超融合一般以集群方式部署，在通用服务器硬件上安装超融合软件，多台通用服务器之间通过以太网互联，构成一个分布式集群。这种架构的扩展模式不依赖提高单台服务器的硬件配置，而是通过不断扩大服务器集群数量持续获得性能提升。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">高可用性与业务连续性</div>
              <div class="desc">多级冗余与自动故障恢复</div>
              <div class="desc">分布式存储采用多副本机制（2/3副本），单节点或硬盘故障时自动切换至健康副本，保障数据零丢失。</div>
              <div class="desc">集成高可用（HA）和容错（FT）技术，业务恢复时间（RTO）达分钟级，恢复点目标（RPO）实现秒级。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">运维效率与敏捷性提升</div>
              <div class="desc">通过单一控制台（如vCenter、深信服aCloud）管理计算、存储、网络资源，提升运维效率。</div>
            </div>
            <el-button type="primary" round class="hx-btn" @click="toZixun">了解超融合平台</el-button>
          </div>
          </el-col>
          <el-col :span="24" class="hidden-sm-and-up" v-if="tabRadio==='3'"><div class="hx-img height3"><img src="../../assets/img/iT/case3-bg.png" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='3'">
            <div class="hx-text height3">
              <div class="title-sub1">多维度保障业务韧性</div>
              <div class="title-sub2">业务容灾解决方案是企业应对自然灾害、硬件故障、网络攻击等突发灾难的核心防御体系，其核心价值在于保障业务连续性、最小化数据丢失、优化成本结构并支撑战略转型。</div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">业务连续性保障</div>
                <div class="desc">通过热备、双活等架构实现秒级RPO（零数据丢失）和分钟级RTO（快速恢复）。支持“两地三中心”（同城双活+异地灾备），应对城市级灾难。如华为云异地多活架构可跨地域切换业务，确保灾难中业务不中断。</div>
              </div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">成本优化与资源高效利用</div>
                <div class="desc">相比传统容灾（需自建冗余硬件），云容灾通过按需付费模式降低成本。超融合架构（如SmartX）支持生产集群兼作灾备资源池，避免独立灾备中心建设，提升硬件利用率。</div>
              </div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">运维效率与敏捷性提升</div>
                <div class="desc">全自动切换（如飞康CDP的微秒级快照）和智能演练（如SMTX容灾的隔离测试）减少人工干预，提升故障恢复效率。</div>
              </div>
              <el-button type="primary" round class="hx-btn"  id="gnys" @click="toZixun">了解业务容灾方案</el-button>
            </div>
          </el-col>
          <el-col :span="12" class="hidden-xs-only" v-if="tabRadio==='3'"><div class="hx-img height3" style="text-align: right"><img src="../../assets/img/iT/case3-bg.png" /></div></el-col>
          <el-col :span="12" :xs="24"  v-if="tabRadio==='4'"><div class="hx-img height2"><img src="../../assets/img/iT/case4-bg.png" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='4'"><div class="hx-text height2">
            <div class="title-sub1">构筑高效可靠的企业数字动脉</div>
            <div class="title-sub2">业务连续性始于稳固的网络根基。我们专注为企业打造高性能、高可用的网络基础设施，通过精准架构设计与前沿技术部署，构建覆盖全场景的数据传输通道。全面支撑企业办公、生产、云端协作等核心业务需求，让数据流转如血脉般顺畅有力，为您的数字化进程铺设坚实跑道。</div>
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">智能区域隔离，清晰安全的网络规划</div>
              <div class="desc">打破“一网到底”的风险隐患。我们基于VLAN（虚拟局域网）技术实现精细化的逻辑分区。有效抑制广播风暴，隔离安全风险，确保敏感业务数据仅在授权区域流通，同时简化运维复杂度，提升整体网络健壮性。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">多重冗余设计，构建永续运行核心网</div>
              <div class="desc">拒绝单点故障导致的业务中断。方案采用多层次冗余架构：</div>
              <div class="desc">设备冗余： 核心交换机堆叠/虚拟化（如VSF、IRF）、关键节点双机热备</div>
              <div class="desc">链路冗余： 骨干万兆光纤多路径聚合（LACP/跨设备Eth-Trunk）</div>
              <div class="desc">路由冗余： OSPF/VRRP协议快速收敛，故障切换毫秒级响应</div>
              <div class="desc">最大限度保障网络持续在线，满足企业关键业务“零中断”诉求。
              </div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">弹性组网架构：全光网与以太网双擎驱动</div>
              <div class="desc">支持无源光网络（PON）方案，采用OLT（光线路终端）+ ONU（光网络单元）+ 分光器结构。适用于大面积多节点场景，降低布线成本与运维负担。</div>
              <div class="desc">长距离覆盖：单模光纤传输达20km，轻松连接分散厂区</div>
              <div class="desc">无源节能：分光节点无需供电，降低机房空间与能耗</div>
              <div class="desc">极简运维：OLT集中管控所有ONU，配置自动化</div>
            </div>
            <el-button type="primary" round class="hx-btn" @click="toZixun">了解企业基础网络建设方案</el-button>
          </div>
          </el-col>
          <el-col :span="24" class="hidden-sm-and-up" v-if="tabRadio==='5'"><div class="hx-img height4" style="text-align: right"><img src="../../assets/img/iT/case5-bg.jpg" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='5'">
            <div class="hx-text height4">
              <div class="title-sub1">重塑企业移动生产力</div>
              <div class="title-sub2">从移动办公到智能制造，稳定高速的无线连接已成为企业竞争力的核心要素。</div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">无线新基建，业务零中断</div>
                <div class="desc">我们提供从规划设计到部署运维的一站式企业级无线网络服务，基于Wi-Fi 6/6E及未来Wi-Fi 7技术，融合智能射频调度、无缝漫游与集中管控能力，打造覆盖无死角、接入高并发、业务零中断的无线新基建，让您的团队在任何角落都能自由协作，激活数字生产力。</div>
              </div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">无缝安全漫游，企业级连接零感知切换</div>
                <div class="desc">三层快速漫游： 802.11k/v/r协议联动，保障移动设备跨区不掉线</div>
                <div class="desc">零感知认证：802.1X + MAC绑定，员工移动时自动识别身份免密接入</div>
                <div class="desc">虚拟无线组：员工/访客/IoT分属不同SSID，逻辑隔离互不可见  </div>
              </div>
<!--              <div class="hx-content">-->
<!--                <div class="line"></div>-->
<!--                <div class="title-sy">高效的多站点监控和管理</div>-->
<!--                <div class="desc">通过自动实时监控、保护和故障排除建议，在 Synology 系统间提前发现潜在问题并提高 IT 运营效率。</div>-->
<!--              </div>-->
              <el-button type="primary" round class="hx-btn"  id="gnys" @click="toZixun">了解无线网络建设方案</el-button>
            </div>
          </el-col>
          <el-col :span="12" class="hidden-xs-only" v-if="tabRadio==='5'"><div class="hx-img height5" style="text-align: right"><img src="../../assets/img/iT/case5-bg.jpg" /></div></el-col>
        </el-row>
      </div>

    </div>
    <div class="tedian" >
      <div class="it_hardware_title_wrap flow-title">
        <div class="it_hardware_inner">
          <div class="inner_center">
            <div class="it_hardware_title" id="fwfc" >产品与设备</div>
            <div class="it_hardware_desc">机房设施 (逻辑分层架构图)</div>
          </div>
        </div>
      </div>
      <div class="title_card"></div>
      <div class="it_hardware_card">
        <img src="../../assets/img/iT/production-device.jpg" class="gaizao hidden-xs-only"/>
        <img src="../../assets/img/iT/jrc.jpg" class="gaizao hidden-sm-and-up"/>
        <img src="../../assets/img/iT/aqc.jpg" class="gaizao hidden-sm-and-up"/>
        <img src="../../assets/img/iT/ccc.jpg" class="gaizao hidden-sm-and-up"/>
        <img src="../../assets/img/iT/wlc.jpg" class="gaizao hidden-sm-and-up"/>
        <img src="../../assets/img/iT/jszyc.jpg" class="gaizao hidden-sm-and-up"/>
        <img src="../../assets/img/iT/jcssc.jpg" class="gaizao hidden-sm-and-up"/>
      </div>
<!--      <span>&nbsp;</span>-->
    </div>
    <div class="hzhb hidden-xs-only"   id="gzfx"><img src="../../assets/img/iT/it-hzhb.jpg"/></div>
    <div class="hzhb hidden-sm-and-up"><img src="../../assets/img/mobile/hezuohuoban.png"/></div>
    <div class="tedian1 padding80" >
      <Zixun :zixun = "centerDialogVisible"/>
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
// import ProCard from './ProCard.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import Zixun from "@/components/zixun/index.vue";
export default {
  data() {
    return {
      activeName:"first",
      centerDialogVisible: false,
      tabRadio: '1',
      cardList: [
        {
          src: require('@/assets/img/solution/hexin1.png'),
          title: '生产管理',
          desc1: '支持离散制造与流程制造模式，灵活应对定制化需求，生产进度实时监控、设备维护计划及工时成本核算',
        },
        {
          src: require('@/assets/img/solution/hexin2.png'),
          title: '质量管理',
          desc1: '全流程质检、质量追溯与改进建议生成',
        },
        {
          src: require('@/assets/img/solution/hexin3.png'),
          title: '财务管理',
          desc1: '成本核算（直接/间接成本）、预算控制、多维财务报表生成',
        },
        {
          src: require('@/assets/img/solution/hexin4.png'),
          title: '物料管理',
          desc1: '动态库存预警、BOM（物料清单）管理、采购与领料自动化',
        },
        {
          src: require('@/assets/img/solution/hexin5.png'),
          title: '供应链协同',
          desc1: '供应商分级评估、采购成本分析、物流状态可视化',
        },
        {
          src: require('@/assets/img/solution/hexin6.png'),
          title: '移动化支持',
          desc1: '手机/PDA终端实现工序汇报、库存查询、审批流程移动化',
        },
      ],
      currentSub:""
    }
  },
  components: {
    Zixun,
    CallMe,
    MobileCallme,
  },
  mounted() {
    this.activeName="first"
    let elements = document.querySelectorAll('.tab-area');
    window.onscroll = () => {
      if(document.documentElement.scrollTop > 420){
        elements.forEach(function(element) {
          element.classList.add('tab-area-fixed');
        });
        if(document.documentElement.scrollTop > 800){
          this.activeName="second"
        }
        if(document.documentElement.scrollTop > 1600){
          this.activeName="third"
        }
        if(document.documentElement.scrollTop > 2800){
          this.activeName="fourth"
        }
      }else {
        this.activeName="first"
        elements.forEach(function (element) {
          element.classList.remove('tab-area-fixed');
        });
      }
    }
  },
  methods:{
    toZixun() {
      this.centerDialogVisible = false;
      this.$nextTick(() => {
        this.centerDialogVisible = true;
      });

    },
    overSub(flag){
      this.currentSub = flag
    },
    outSub(){
      this.currentSub = ''
    },
    handleClick(){
      if(this.activeName==="first"){
        const element = document.getElementById('cpjz');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
      if(this.activeName==="second"){
        const element = document.getElementById('jsfa');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
      if(this.activeName==="third"){
        const element = document.getElementById('fwfc');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
      if(this.activeName==="fourth"){
        const element = document.getElementById('gzfx');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.tedian1 {
  background-color: #F5F7FA;
  padding: 5px 0 5px 0;
  margin-top: -5px;
}
.tedian{
  background-color:#ffffff;
  padding: 5px 0 5px 0 ;
  @media screen and (max-width: 768px) {
    //padding-bottom: 10PX;
  }
  .title_card{
    width: 80%;
    margin: 40px auto 0 auto;
    @media screen and (max-width: 768px) {
      width: 95%;
      //overflow-x: auto;
      padding-bottom: 5px;
    }
    img{
      width: 100%;
      margin-bottom: 0;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }
  }
  .it_hardware_card{
    margin-top: 20px !important;
  }

}
.it_hardware_wrap {
  width: 100%;
  margin-top: 70px;
  @media screen and (max-width: 768px) {
    background-color: #f8fafd;
  }
  .it_hardware_inner{
    @media screen and (max-width: 768px) {
      padding: 20PX 0 0 0;
    }
  }
  .it_hardware_img {
    background: url('../../assets/img/iT/iT-banner.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 768px) {
      background-size: cover ;
      background-position: 45% 100%;
    }
  }
  .it_hardware_title_wrap {
    width: 100%;
    margin-top: 50px;
    //padding-bottom: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
      //padding-bottom: 20PX;
    }
  }

  .dingwei-bottom{
    width: 100%;
    height: 400px;
    margin-bottom: 50px;
    background: url('../../assets/img/iT/IT_bg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    justify-items: center;
    justify-content: center;
    align-items: center;
    display: flex;
    @media screen and (max-width: 768px) {
      height: 260PX;
      background-size: cover ;
      background-position: 70% 100%;
    }
    .it_hardware_desc{
      padding-top: 20px;
      font-size:20px ;
      color: #fff;
      @media screen and (max-width: 768px) {
        width: 80%;
        text-align: center;
        font-size: 0.8rem;
        line-height: 1.2rem;
      }
    }
    .it_hardware_title{
      font-size:34px ;
      color: #fff;
      @media screen and (max-width: 768px) {
        width: 80%;
        text-align: center;
        font-size: 1.1rem;
        line-height: 1.5rem;
        padding-top: 10px;
      }
    }
  }
  .dingwei-bg{
    background: url('../../assets/img/solution/dingwei-bg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    border-radius: 4px;
    padding: 60px 40px 60px 40px !important;

    img{
      margin-bottom: 10px;
      width: 100% !important;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }
    .it_hardware_item {
      width: calc(100% / 4 - 20px) !important; /* 减去间距 */
      margin: 8px 10px !important; /* 可根据需要调整 */
      padding-right: 0 !important;
      background-color: #fff;
      border-radius: 6px;
      display: unset !important;
      border: 1px solid rgba(224, 236, 255, 1);
      box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.05);
    }
    .title{
      font-size: 20px !important;
      padding: 15px 15px 30px 15px;
      text-align: center;
      .content{
        text-align: left;
        font-size: 13px !important;
      }
    }

  }
  .bottom{
    width: 60%;
    margin: auto;
    text-align: center;
    margin-top: -80px;
    color: rgba(37, 53, 84, 0.5);
    font-size: 14px;
  }
  .it_hardware_box {
    margin: auto;
    width: 70%;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 10px;
    @media screen and (max-width: 768px) {
      width: 95%;
      justify-content: space-around;
      flex-wrap: wrap;
      margin-top: 10PX;
      margin-bottom: 30PX;
    }
    .bg{
      width: 100%;
      border-radius: 4px;
    }
    .it_hardware_item {
      width: calc(100% / 4 - 12px); /* 减去间距 */
      margin: 8px 6px; /* 可根据需要调整 */
      padding-right: 40px;
      display: flex;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin-left: 0;
        margin-top: 10PX;
        box-shadow: 2px 2px 5px 2px rgba(12, 28, 56, 0.05);
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        padding: 20px 10px;
        border: 1px solid rgba(224, 236, 255, 1);

      }
      .title{
        width: 100%;
        font-size: 24px;
        color: rgba(37, 53, 84, 1);
        @media screen and (max-width: 768px) {
          font-size: 0.9rem;
          line-height: 1.5rem;
          font-weight: bold;
        }
        img{
          margin-bottom: 10px;
          width: 60px;
          @media screen and (max-width: 768px) {
            width:40PX;
            float: left;
            margin-right: 15PX;
          }
        }
        .content{
          margin-top: 10px;
          font-size: 14px;
          line-height: 24px;
          color: rgba(37, 53, 84, 0.6);
          @media screen and (max-width: 768px) {
            font-size: 0.7rem;
            line-height: 1.2rem;
            margin-left: 55PX;
            font-weight: normal;
          }
        }
        .second-content{
          margin-top: 0;
        }
      }
    }
  }
  p {
    text-align: center;
    color: #3b3b3b;
    font-weight: bold;
    font-size: 20px;
    line-height: 100px;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      padding: 15px 0;
    }
  }
  .service-card {
    width: 100%;
    margin: 50px auto;
    background-color: #fff;
    @media screen and (max-width: 768px) {
      margin: 18PX auto 0 auto;
      padding-bottom: 5PX;
    }
  }
  .it_hardware_card {

    width: 70%;
    margin: 50px auto;
    @media screen and (max-width: 768px) {
      width: 95%;
      margin: 20PX auto;
    }

    .title-div{
      img{
        float: left;
        height: 30px;
        width: 1px;
        margin-top: 5px;
      }
      .title{
        float: left;
        font-size: 32px;
        line-height: 40px;
        font-weight: bold;
        color: #05102F;
        padding-right: 15px;
      }
      .desc{
        float: left;
        font-size: 22px;
        line-height: 40px;
        color: #808080;
        padding-left: 15px;
      }
    }
    .item-content{
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 50px 0;
      .sub-item-yzs{
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #E0ECFF;
        padding: 10px;
        box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.1);
        width: calc(100% / 5 - 10px); /* 减去间距 */
        margin-right: 20px;
        .down-card{
          width: 100%;
          padding: 0 8px 0px 8px;
          color: #808080;
          line-height: 26px;
          font-size: 13px;
        }
        .up-card{
          display: flex;
          line-height: 60px;
          font-size: 22px;
          color: #16181A;
          font-weight: bold;
          img{
            width: 28%;
            margin-right: 5px;
          }
        }
        &:hover{
          box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.2);
          .up-card{
            color: #0052D9;
          }
        }
      }

    }
  }
  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .carousel_pro {
    width: 60%;
    margin: 60px auto;
    .carousel_pro_item {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

}
.basic-area{
  margin: auto;width: 70%;
  padding: 0 14px 30px 14px;

  .title{
    border-radius: 8px;color: #fff;
    background: #3393FD;
    line-height: 40px;
    text-align: center;
  }
  .content{
    border-radius: 8px;
    background: linear-gradient(180deg, #F6F8FF 0%, #D9E6FA 100%);
    border: 2px dashed #a3c4fe;
    width: 100%;
    margin-top: 10px;
    padding: 15px 8px;
    display: flex;
    .content-item{
      padding: 20px;
      text-align: center;
      margin: 0 1%;
      //float: left;
      width: 9%;
      border: 2px dashed #a3c4fe;
      background-color: #FBFDFF;
      border-radius: 8px;
      align-content: center;
      color: #05102F;
    }

  }
}
.it_hardware_core_scene{
  background-color: #F5F7FA;
  width: 70%;
  margin: 30px auto;
  padding: 30px 50px 20px 50px;
  height: 350px;
  border-radius: 4px;
  background: linear-gradient(180deg, rgba(2, 99, 255, 1) 41.2%, rgba(131, 181, 254, 1) 100%);
  .it_hardware_core_scene_title{
    align-content: center;
    color: #fff;
    letter-spacing: 2px;
    padding-bottom: 20px;
    .sub1{
      font-size: 32px;
      margin-right: 10px;
      font-weight: bold;
      line-height: 40px;
      float: left;
    }
    img{
      float: left;
      height: 30px;
      margin-top: 5px;
      width: 1px;
    }
    .sub2{
      margin-left: 10px;
      font-size: 20px;
      line-height: 40px;
      float: left;
    }
  }
  .item-bg{
    float: left;
    width: 24%;
    img{
      width: 90%;
    }
  }
  .item{
    float: left;
    width: 16%;
    padding: 0 20px;
    margin-left: 3%;
    text-align: center;
    border-radius: 4px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 39.8%, rgba(255, 255, 255, 0.8) 64.35%, rgba(255, 255, 255, 0.6) 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 230px;
    font-size: 12px;
    color: #8491AB;
    .bg{
      width: 46%;
    }
    .hx{
      margin: 10px 0;
      width: 100%;
    }
    .btn-area{
      width: 100%;
    }
    .left-div{
      flex: 1;
      width: 48%;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
      margin-right: 2%;
    }
    .right-div{
      width: 48%;
      flex: 1;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
    }
    span{
      font-size: 20px;
      line-height: 40px;
      font-weight: bold;
      color: #253554;
    }
  }

}
.tab-area{
  margin: auto;
  width: 100%;
  .tabs{
    margin: 0 15%;
    margin-top: -50px;
  }
  .tab-area-bg{
    background: #FFFFFF;
    height: 60px;
    box-shadow: 0 4px 12px rgba(12, 28, 56, 0.2);
  }
}
.tab-area-fixed{
  position: fixed;
  top: 70px;
  z-index: 999;
}
::v-deep(.el-tabs__nav-wrap::after){
  background-color: #fff !important;
}
::v-deep(.el-tabs__item ){
  margin-bottom: 10px;
}
::v-deep(.el-tabs__item.is-active ){
  color: #0052D9  !important;
}
::v-deep(.el-tabs__active-bar){
  background-color: #0052D9  !important;
  height: 3px;
}
.shenru-btn {
  width: 180px;
  height: 40px;
  background: #0052D9;
  color: #fff;
  bottom: 15%;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.5s;
  margin: 30px auto 10px auto;
  &:hover {
    color: #fff;
    font-weight: bold;
    background: #24b1ff;
  }
  @media screen and (max-width: 768px) {
    width: 80px;
    height: 30px;
    font-size: 14px;
  }
}
.gaizao{
  width: 100%;
  margin-bottom: 20px;
}
.padding80{
  padding-top: 80px
}
.card_wrap {
  width: 70%;
  flex-wrap: wrap;
  margin: 0px auto;
  justify-content: space-between;
  padding-bottom: 20px;
  @media screen and (max-width: 768px) {
    width: 95%;
    padding-bottom: 30PX;
  }
  .brain_item {
    transition: background-color 1s;
    padding: 20px 5px;
    //background: #fff;
    border-radius: 4px;
    border: 2px solid #fff;
    background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
    box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 10%);
    margin-top: 40px;
    position: relative;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      border-radius: 4PX;
      display: flex;
      flex-wrap: wrap;
      justify-content: start;
      margin-top: 10PX;
      padding: 15PX 5PX;
      background: linear-gradient(180deg, rgba(237, 241, 252, 1) 0%, rgba(255, 255, 255, 1) 100%);
    }
    .img_item {
      margin-top: 10px;
      width: 90% ;
      @media screen and (max-width: 768px) {
        width: 70% ;
      }
    }
    &:hover{
      box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 18%);
    }
    .item_bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
      //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 12%);
      opacity: 0;
      transition: all 0.5s;
      border-radius: 4px;
      z-index: 1;
      border: 1px solid #fff;
    }
    &:hover .item_bg{
      opacity: 1;
    }
    &:hover .item_title {
      color: #0052D9;
    }
    //&:hover .item_desc {
    //  color: #0052D9;
    //}
    .item_title {
      transition: all 0.5s;
      font-size: 18px;
      font-weight: bold;
      color: #203040;
      text-align: left;
      padding: 10px 0 10px 0;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        font-size: 1rem;
      }
    }
    .item_desc {
      width: 90%;
      transition: all 0.5s;
      color: #666;
      text-align: left;
      line-height: 24px;
      z-index: 2;
      position: inherit;
      font-size: 13px;
      min-height: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 1.2rem;
      }
      i{
        padding-right: 5px;
        color: #19B21E;
        font-weight: bold
      }
    }
    .item_navigate {
      width: 100PX;
      height: 30PX;
      padding: 0 10px;
      background: #ffa400;
      color: #fff;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      margin-top: 40px;
      cursor: pointer;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        margin-bottom: 10PX;
        font-size: 14px;
      }
    }
  }
}
.flow-title{
  padding-bottom: 0 !important;
}
.con{
  padding-left: 18px;
}
.center-area{
  background-color: #fff;
  width: 70%;
  margin: auto;
  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 2.5%;
    margin-top: 10PX;
  }

  .tab-content{
    margin-bottom: 120px;
    //@media screen and (max-width: 768px) {
    //  width: 95%;
    //  margin-bottom: 50PX;
    //}
    .el-radio-group {
      width: 80%;
      margin:40px auto 20px auto;
      display: flex;
      justify-content: center;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }
    ::v-deep(.el-radio-button:first-child .el-radio-button__inner) {
      border-radius: 0 !important;
    }
    ::v-deep(.el-radio-button:last-child .el-radio-button__inner) {
      border-radius: 0 !important;
    }
    ::v-deep(.el-radio-button__orig-radio:checked+.el-radio-button__inner){
      background-color: #0052D9 !important;
      border: 1px solid #0052D9 !important;
    }
    ::v-deep(.el-radio-button) {
      width: calc(100%/6 - 4px);
      text-align: center;
      @media screen and (max-width: 768px) {
        width: calc(100%/3 - 4px);
      }
    }
    ::v-deep(.el-radio-button__inner) {
      width: 90%;
      margin: auto;
      background-color: #F2F2F2;
      border: 1px solid #F2F2F2;
      -webkit-box-shadow: unset;
      box-shadow: unset;
      padding: 14px;
      @media screen and (max-width: 768px) {
        padding: 7PX;
        font-size: 0.8rem;
      }
    }
    .half-inner{
      width:12.5%;
      float: left;
      ::v-deep(.el-radio-button) {
        width: 100% !important;
        text-align: right;
      }
      .el-radio-group {
        width: 100%;
        //float: left;
      }


    }
    .half-inner-middle{
      width:100%;
      float: left;
      ::v-deep(.el-radio-button) {
        width: calc(100%/2 - 4px) !important;
        text-align: center;
        @media screen and (max-width: 768px) {
          width: 100%;
          padding-top: 2PX;
        }
      }
      .el-radio-group {
        width: 100%;
      }
      ::v-deep(.el-radio-button__orig-radio:checked+.el-radio-button__inner){
        background-color: #fff !important;
        color: #0052d9;
        border: 1px solid #fff !important;
      }

      ::v-deep(.el-radio-button__inner) {
        width: 90%;
        margin: auto;
        background-color: #fff;
        border: 1px solid #fff;
        -webkit-box-shadow: unset;
        box-shadow: unset;
        padding: 14px;
      }
    }
    .half-inner-right{
      width:100%;
      float: left;
      //@media screen and (max-width: 768px) {
      //  width: 100%;
      //}
      ::v-deep(.el-radio-button) {
        width: calc(100%/3 - 6px) !important;
        text-align: center;

        @media screen and (max-width: 768px) {
          width: 100%;
          padding-top: 10PX;
          padding-bottom: 20PX;
        }
      }
      .el-radio-group {
        width: 100%;
      }
      ::v-deep(.el-radio-button__orig-radio:checked+.el-radio-button__inner){
        background-color: #fff !important;
        color: #0052d9;
        border: 1px solid #fff !important;
      }

      ::v-deep(.el-radio-button__inner) {
        width: 90%;
        margin: auto;
        background-color: #fff;
        border: 1px solid #fff;
        -webkit-box-shadow: unset;
        box-shadow: unset;
        padding: 14px;
      }
    }

  }
}
.row-div{
  width: 100%;
  padding-bottom: 30px;
  @media screen and (max-width: 768px) {
    padding-top: 10PX;
  }

}
.hx-desc{
  font-size: 14px;
  color: #808080;
  line-height: 24px;
  text-align: center;
  @media screen and (max-width: 768px) {
    font-size: 0.7rem;

    line-height: 1.2rem;
  }
}
.height1{
  height: 550px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.height2{
  height: 660px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.height3{
  height: 500px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.height4{
  height: 350px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.height5{
  height: 480px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.hx-text{
  padding: 20px 20px 20px 15px;
  @media screen and (max-width: 768px) {
    padding: 10PX 10PX 10PX 10PX;
  }
  .title-sub1{
    color: #05102F;
    font-size: 26px;
    font-weight: bold;
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
  .title-sub2{
    color: #808080;
    font-size: 16px;
    margin-top: 15px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 1.2rem;
    }
  }
}
.hx-btn{
  background-color: #0052D9;
  margin-top: 20px;
  font-size: 14px;
  @media screen and (max-width: 768px) {
    font-size: 0.7rem;
    width: 180PX;
    line-height: 1.8rem;
    border-radius: 50PX;
    margin-top: 20PX;
  }
}
.hx-content-height1{
  @media screen and (max-width: 768px) {
    height: auto !important;
  }
}
.hx-content-height2{
  @media screen and (max-width: 768px) {
    height: auto;
  }
}
.hx-content{
  margin-top: 30px;
  //height: 86px;
  border-left: 5px solid rgb(0, 82, 217,0.6);
  padding-left: 10px;
  @media screen and (max-width: 768px) {
    margin-top: 15PX;
    height: auto;
    border-left: 3PX solid rgb(0, 82, 217,0.6);
    padding-left: 10PX;
  }
  .line{
    display: none;
    float: left;
    height: 100%;
    width: 4px;
    background-color: rgb(0, 82, 217,0.6);
    margin-right: 10px;
    @media screen and (max-width: 768px) {
      height: 90PX;
      width: 2PX;
      margin-right: 10PX;
      display: none;
    }
  }
  &:hover{
    border-color: rgb(0, 82, 217, 1);;
    .line {
      background-color: rgb(0, 82, 217, 1);
    }
    .title {
      color: rgb(0, 82, 217, 1);
      font-weight: bold;
    }
  }
  .title-sy{
    color: #05102F;
    font-size: 20px;
    margin-bottom: 5px;
    @media screen and (max-width: 768px) {
      font-size: 0.85rem;
      line-height: 1.5rem;
    }

  }
  .desc{
    color: rgb(128, 128, 128);
    font-size: 14px;
    padding-bottom: 5px;
    @media screen and (max-width: 768px) {
      font-size: 0.7rem;
      line-height: 1.2rem;
    }
  }
}
.hx-img{
  align-content: center;
  align-items: center;
  text-align: center;
  display: grid;
  @media screen and (max-width: 768px) {
    margin-bottom: 20PX;
  }
  img{
    width: 95%;
    //border-radius: 10px;
    @media screen and (max-width: 768px) {
      width: 100%;
      border-radius: 6PX;
    }
  }
}

.hzhb {
  width: 100%;

  img {
    width: 100%;
  }
;
}
</style>